/**
 * Validation utility functions for XpressTicket
 */

/**
 * Validate an email address format
 * @param {string} email - The email address to validate
 * @returns {boolean} True if valid email format
 */
export function isValidEmail(email) {
  const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return regex.test(email);
}
